// Initilise the Tender supplier page
var TECL_TenderSupplierSelect = {

  // Initialise the Tenders select page
  Initialise: function () {
    TECL_TenderSupplierGeneral.InitialiseAccordionControls();

    window.scrollTo(0, 0);

    // Open the accordian for active tenders
    var collapseNodes = $("#accordion_ActiveTenders").find(".panel-collapse");
    if (collapseNodes.length > 0) {
      collapseNodes.collapse("show");
    }

    // Handle when the 'various' link is clicked in the region col
    $("body").on("click", "a.various-regions", function () {
      var $variousBtn = $(this);
      var $modal = $("#projectRegionsInfoDlg");
      // Get the regions info
      var regionsList = $variousBtn.attr("data-regionsInfo");
      var regionsArray = regionsList.split(",");
      var regionsOutput = regionsArray[0];
      // Create the regions output
      for (var i = 1; i < regionsArray.length; i++) {
        regionsOutput = regionsOutput + ", " + regionsArray[i];
      }
      $modal.find(".regions-list").html(regionsOutput);
      $modal.modal("show");
    });

    // Initialise tender cancelling
    TECL_TenderCancelModule.Initialise();
  }

};